import React, { useEffect } from "react";

import moment from "moment";
import {
  BiCheck,
  BiCloud,
  BiCloudUpload,
  BiCopy,
  BiExport,
  BiTrashAlt,
  BiX,
} from "react-icons/bi";
import { FaCalendar } from "react-icons/fa";
import { FiClock } from "react-icons/fi";
import { PiFileFill } from "react-icons/pi";
import { useCustomContextMenu } from "src/components/UseContextMenu";
import { twMerge } from "tailwind-merge";
import { ProtocolLI } from "../../../fithub-shared/interfaces/protocol";
import { GetLocal } from "../../cache/protocol-manager";

interface ItemProps {
  index: number;
  selected: boolean;
  onUpdate: () => void;
  onSelected: () => void;
  onUnselect: () => void;
  onRemove: (id: string) => void;
  onDuplicate: (id: string) => void;
  onExport: (id: string) => void;
  onSaveTemplate: (id: string) => void;
  item: ProtocolLI;
  template: boolean;
}

const ProtocolItem: React.FC<ItemProps> = (props) => {
  const { enable, disable, active } = props.item;

  useEffect(() => {
    console.log("ref");
  }, [enable, disable, active]);

  const { showContextMenu, closeContextMenu, ContextMenu } =
    useCustomContextMenu();

  const contextItems = [
    { title: "Duplicar", icon: BiCopy, action: Duplicate },
    { title: "Exportar", icon: BiExport, action: Export },
    {
      title: "Salvar como Template",
      icon: BiCloudUpload,
      action: SaveTemplate,
    },
    { title: "Deletar", icon: BiTrashAlt, action: Delete },
  ];

  function OnClick() {
    props.onSelected();
  }

  function Delete() {
    closeContextMenu();
    props.onRemove(props.item.id);
  }

  function Export() {
    closeContextMenu();
    props.onExport(props.item.id);
  }

  function Duplicate() {
    closeContextMenu();
    props.onDuplicate(props.item.id);
  }

  function SaveTemplate() {
    if (!GetLocal(props.item.id)) {
      props.onSaveTemplate(props.item.id);
    }

    closeContextMenu();
  }

  const handleContextMenu = (e: React.MouseEvent<HTMLDivElement>) => {
    showContextMenu(e, contextItems);
  };

  const Indicator = () => {
    const enableTime = new Date(enable ?? "").getTime() > Date.now();

    return !active && enable && enableTime ? (
      <div
        style={{
          alignItems: "center",
          paddingBottom: 1,
        }}
      >
        <FiClock color="white" size={17} />
      </div>
    ) : active ? (
      <BiCheck color="lightgreen" size={24} />
    ) : (
      <BiX color="red" size={24} />
    );
  };

  const count = props.item.wcached ?? 0;

  const remaining = () => {
    if (active && disable) {
      const daysRemaining = moment(disable).diff(Date.now(), "days");
      const plural = daysRemaining === 1 ? "" : "s";
      return `, ${daysRemaining} dia${plural} restante${plural}`;
    } else if (active === false && enable) {
      const daysUntilActive = moment(enable).diff(Date.now(), "days");
      return `, ativa em ${daysUntilActive} dias`;
    } else return undefined;
  };

  return (
    <div
      className={twMerge(
        "relative my-1 flex h-[55px] w-full items-center justify-between rounded-lg px-1",
        props.selected
          ? "bg-zinc-200 font-bold dark:bg-zinc-700"
          : "bg-transparent",
        "font-semibold text-black dark:text-white", // <-- Adicionei text-black aqui
      )}
      onContextMenu={handleContextMenu}
    >
      <ContextMenu />

      {props.template ? (
        <BiCloud color="#444" size={24} />
      ) : (
        <div className="relative flex h-6 w-10 items-center justify-center rounded-full bg-gray-500">
          {Indicator()}
        </div>
      )}

      <div
        className="flex h-full flex-1 cursor-pointer flex-col justify-between overflow-hidden px-1"
        onClick={OnClick}
      >
        <div className="flex flex-row items-center justify-between pt-2 font-normal">
          <h4
            className={twMerge(
              "w-full min-w-0 truncate text-[13px] text-black dark:text-white",
            )}
          >
            {props.item.title}
          </h4>
          <div className="flex items-center justify-end">
            <p className="w-full flex-1 text-ellipsis whitespace-nowrap text-[10px] font-bold">
              {props.item.wcount ?? 0}
            </p>
            <span className="mx-1" />
            <PiFileFill color="#555" size={12} />
          </div>
        </div>

        <div className="flex flex-row items-center justify-between pb-2 font-normal">
          <div className="flex min-w-0 flex-row items-center">
            <h5
              className={twMerge(
                "overflow-hidden truncate whitespace-nowrap text-[12px]",
                count > 0 ? "text-primary" : "text-gray-500",
              )}
            >
              {count > 0
                ? `${count} Modificado${count > 1 ? "s" : ""}`
                : "Salvo"}
              {remaining && (
                <strong className="text-gray-600">{remaining()}</strong>
              )}
            </h5>
          </div>
          <div className="flex items-center justify-end">
            <p className="w-full flex-1 text-ellipsis whitespace-nowrap text-[10px] font-bold">
              {moment(props.item.created_at).format("DD/MM/yyyy, HH:mm")}
            </p>
            <span className="mx-1" />
            <FaCalendar color="#555" size={12} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProtocolItem;
